export type ElaAssignmentType =
  | 'ela_assessment'
  | 'ela_article'
  | 'ela_word_study'
  | 'ela_adaptive_skills'
  | 'ela_targeted_skills'
  | 'ela_decodable'
  | 'ela_focus_skills_practice'

type ElaAssignmentTypesT = {
  ElaAssessment: ElaAssignmentType
  ElaArticle: ElaAssignmentType
  ElaWordStudy: ElaAssignmentType
  ElaAdaptiveSkills: ElaAssignmentType
  ElaTargetedSkills: ElaAssignmentType
  ElaDecodable: ElaAssignmentType
  ElaFocusSkillsPractice: ElaAssignmentType
  all: () => Array<ElaAssignmentType>
  forDisplay: (elaAssignmentType: ElaAssignmentType) => string
  parse: (text: string) => ElaAssignmentType | undefined | null
}

export const ElaAssignmentTypes: ElaAssignmentTypesT = {
  ElaAssessment: 'ela_assessment',
  ElaArticle: 'ela_article',
  ElaWordStudy: 'ela_word_study',
  ElaAdaptiveSkills: 'ela_adaptive_skills',
  ElaTargetedSkills: 'ela_targeted_skills',
  ElaDecodable: 'ela_decodable',
  ElaFocusSkillsPractice: 'ela_focus_skills_practice',
  all: function (): Array<ElaAssignmentType> {
    return [
      ElaAssignmentTypes.ElaAssessment,
      ElaAssignmentTypes.ElaArticle,
      ElaAssignmentTypes.ElaWordStudy,
      ElaAssignmentTypes.ElaAdaptiveSkills,
      ElaAssignmentTypes.ElaTargetedSkills,
      ElaAssignmentTypes.ElaDecodable,
      ElaAssignmentTypes.ElaFocusSkillsPractice
    ]
  },

  forDisplay: function (elaAssignmentType: ElaAssignmentType): string {
    return elaAssignmentType.replace(/_/g, '-')
  },

  parse: function (text: string): ElaAssignmentType | undefined | null {
    const trimmed = text.trim()
    return ElaAssignmentTypes.all().find(assignmentType => assignmentType === trimmed)
  }
}
